import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fade from './Fade';
import Collapse from './Collapse';
import Highlight from './Highlight';

// Stylesheets
import './TransitionAnimated.scss';
import { Choose, Otherwise, When } from '../../../renderConditional';

class TransitionAnimated extends Component {
  state = { show: false };

  componentDidMount() {
    this.setState({ show: true });
  }

  render() {
    const { show } = this.state;
    const {
      type,
      duration,
      timeout,
      animationFrom,
      defaultColor,
      highlightColor,
    } = this.props;
    return (
      <Choose>
        <When condition={type === 'highlight'}>
          <Highlight
            children={this.props.children} // eslint-disable-line react/no-children-prop
            duration={duration}
            timeout={timeout}
            defaultColor={defaultColor}
            highlightColor={highlightColor}
          />
        </When>
        <When condition={type === 'collapse'}>
          <Collapse
            in={this.props.show || show}
            children={this.props.children} // eslint-disable-line react/no-children-prop
            duration={duration}
            timeout={timeout}
            animationFrom={animationFrom}
          />
        </When>
        <Otherwise>
          <Fade
            in={show}
            children={this.props.children} // eslint-disable-line react/no-children-prop
            duration={duration}
            timeout={timeout}
            animationFrom={animationFrom}
          />
        </Otherwise>
      </Choose>
    );
  }
}

TransitionAnimated.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  show: PropTypes.bool,
  duration: PropTypes.number,
  timeout: PropTypes.number,
  animationFrom: PropTypes.string,
  defaultColor: PropTypes.string,
  highlightColor: PropTypes.string,
  type: PropTypes.any,
};

export default TransitionAnimated;
